export default "__VITE_ASSET__CwKHAsHf__"